/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class PxeProductizationGetService extends BaseService {
  constructor() {
    super(constants.PXE_PRODUCTIZATION_FETCHED, 'pxeProductizationStatus');
  }

  handleEvent(eventName, event) {
    if (event.productId) {
      return this.getClient('evergreen').get(`/products/${event.productId}`);
    }
    return null;
  }

  handleResponse(response, event) {
    // eslint-disable-line class-methods-use-this
    if (event.productId) {
      const store = Framework.getStoreRegistry().getStore('pxeProductizationState');
      const body = response.data;

      if (response.status === 200) {
        store.set({
          productId: event.productId,
          productData: body || null,
          isValid: true,
          validationError: ''
        });
      } else {
        store.set({
          productId: event.productId,
          productData: null,
          isValid: false,
          validationError: constants.ENTER_VALID_PDZ_PRODUCT_ID
        });
      }
    }
  }

  handleError(error, event) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (event.productId) {
      const store = Framework.getStoreRegistry().getStore('pxeProductizationState');
      store.set({
        productId: event.productId,
        productData: null,
        isValid: false,
        validationError: constants.ENTER_VALID_PDZ_PRODUCT_ID
      });
    }
    if (response && response.status === 401) {
      utils.redirectToLogin();
    }
  }
}
